module.exports = __webpack_public_path__ + "img/volume.ed930085.svg";